export default {"src":"/_next/static/media/baby_24.b214b7ed.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};